import { Box } from '@mui/material';
import type { ReactNode } from 'react';

export type StatePanelProps = {
  testId: string;
  children: ReactNode;
};

// Shared footprint for the shell's page-lifecycle states (loading/empty/error) so
// swapping between them doesn't visibly shift layout.
export const StatePanel = ({ testId, children }: StatePanelProps) => (
  <Box
    data-testid={testId}
    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, py: 8 }}
  >
    {children}
  </Box>
);
